<template>
    <svg :height="size" :width="size" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: sketchtool 55 (78076) - https://sketchapp.com -->
        <title>2FF01DC4-1224-497C-8A14-6DC787C7FC95</title>
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="E-PH-4---Photo-Upload---Review-Multiple" transform="translate(-860.000000, -325.000000)" :fill="fillColor" fill-rule="nonzero">
                <g id="Group-11" transform="translate(72.000000, 151.000000)">
                    <g id="Group-10" transform="translate(0.000000, 19.000000)">
                        <g id="Group-4" transform="translate(788.000000, 155.000000)">
                            <g id="Group-6-Copy">
                                <path d="M17,34 C26.3888407,34 34,26.3888407 34,17 C34,7.61115925 26.3888407,0 17,0 C7.61115925,0 0,7.61115925 0,17 C0,26.3888407 7.61115925,34 17,34 Z M17,32 C8.71572875,32 2,25.2842712 2,17 C2,8.71572875 8.71572875,2 17,2 C25.2842712,2 32,8.71572875 32,17 C32,25.2842712 25.2842712,32 17,32 Z" id="Oval"></path>
                                <g id="Group-2" transform="translate(8.140350, 9.736544)">
                                    <rect id="Rectangle" transform="translate(11.282486, 7.000000) rotate(-315.000000) translate(-11.282486, -7.000000) " x="10.2824856" y="-1" width="2" height="16"></rect>
                                    <polygon id="Rectangle-Copy-13" transform="translate(3.964466, 9.631728) rotate(-585.000000) translate(-3.964466, -9.631728) " points="3.04657925 5.31801948 4.92893219 5.31801948 4.88235294 13.9454365 3 13.9454365"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconCheckCircle",
    props: {
        size: {
            type: Number,
            default: 24,
        },
        fill: {
            type: String,
            default: '#BABFC4'
        },
        activeFill: {
            type: String,
            default: '#e75300'
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        fillColor(){
            if(this.isActive) {
                return this.activeFill;
            }
            return this.fill;
        }
    }
};
</script>